import './Animation.css';
document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll(".lpcb-block-animation-on-scroll");

    if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const target = entry.target;
                        const animation = target.getAttribute("data-animation");

                        if (animation && animation !== "none") {
                            target.classList.add("animate__animated", `animate__${animation}`);
                            const onEnd = (e) => {
                                // 子要素の animationend を無視(イベントの発生元が親自身のときだけ処理)
                                if (e.target !== target) return; 
                                // カーテンアニメーションの場合
                                if (animation === "singleCurtain" || animation === "doubleCurtain") {
                                    target.classList.add("lpcb-curtain-finished");
                                }
                                // 一度アニメーションしたら削除
                                target.classList.remove("animate__animated", `animate__${animation}`);
                                target.classList.remove("lpcb-block-animation-on-scroll");
                                target.removeEventListener("animationend", onEnd);
                            };
                            target.addEventListener("animationend", onEnd);
                        }
                        observer.unobserve(target); // 監視を解除
                    }
                });
            },
            {
                threshold: 0.3, // 指定数以上見えたら発火
            }
        );

        elements.forEach((el) => observer.observe(el));
    }
});
